<template>
  <div v-if="isShow">
    <div class="top-btn" data-io-click="tracker"  @click="handleScrollTop">
      <i class="iconfont icon-arrow-up-to-line"></i>
      <span>顶部</span>
    </div>
  </div>
</template>
<script>
import util from "@/assets/js/common/util";
export default {
  props: {
    visibile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  watch: {
    visibile: {
      handler(val) {
        // if()
        // this.isShow = val
      },
      immediate: true,
    },
    $route: {
      handler(to, from) {
        // console.log('to,from',to,from)
        if (!from || from.path != to.path) {
          this.isShow = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandleDebounce, true);
  },
  destroyed() {
    window.addEventListener("scroll", this.scrollHandleDebounce, true);
  },
  methods: {
    scrollHandleDebounce(e) {
      util.throttle(this.handleScroll, 500)(e);
    },
    handleScrollTop() {
      // console.log("点击");
      let pageMain = document.getElementsByClassName("page-main");
      let layoutMain = document.getElementsByClassName("school-box");
      let documentMain = document.getElementsByClassName("document-content");
      // console.log('layoutMain',layoutMain)
      pageMain = pageMain.length ? pageMain : layoutMain;
      pageMain = pageMain ? pageMain[0] : null;
      if (this.$route.path.indexOf("/zyk") > -1) {
        pageMain = documentMain.length ? documentMain[0] : pageMain;
      }
      pageMain &&
        pageMain.scroll({
          top: 0,
          behavior: "smooth",
        });
    },
    handleScroll(e) {
      let pageMain = document.getElementsByClassName("page-main");
      // console.log("pageMain", pageMain);
      let layoutMain = document.getElementsByClassName("school-box");
      let documentMain = document.getElementsByClassName("document-content");
      // console.log('layoutMain',layoutMain)
      pageMain = pageMain.length ? pageMain : layoutMain;
      // console.log("pageMain", pageMain);
      pageMain = pageMain ? pageMain[0] : null;
      if (this.$route.path.indexOf("/zyk") > -1) {
        pageMain = documentMain.length ? documentMain[0] : pageMain;
      }
      let scrollTop = pageMain ? pageMain.scrollTop : 0;
      // console.log(this.visibile,scrollTop)
      this.isShow = this.visibile && scrollTop > 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.top-btn {
  position: fixed;
  right: 0;
  bottom: 173px;
  width: 31px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px 0 2px;
  color: #fff;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
  i {
    font-size: 24px;
  }
  span {
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
